"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMediaQueryListener = addMediaQueryListener;
exports.removeMediaQueryListener = removeMediaQueryListener;
function addMediaQueryListener(mediaQuery, cb) {
  if (mediaQuery !== null && mediaQuery !== void 0 && mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', cb);
  } else if (mediaQuery !== null && mediaQuery !== void 0 && mediaQuery.addListener) {
    // addListener is required for legacy browsers such as Safari 13
    mediaQuery.addListener(cb);
  }
}
function removeMediaQueryListener(mediaQuery, cb) {
  if (mediaQuery !== null && mediaQuery !== void 0 && mediaQuery.removeEventListener) {
    mediaQuery.removeEventListener('change', cb);
  } else if (mediaQuery !== null && mediaQuery !== void 0 && mediaQuery.removeListener) {
    // removeListener is required for legacy browsers such as Safari 13
    mediaQuery.removeListener(cb);
  }
}